import { configureStore } from "@reduxjs/toolkit";
import proposals from "./ducks/proposals";

export default configureStore({
  reducer: { proposals }
});
